import { DEFAULT_LANG } from '../conf/languages';
import {
	PERMISSION_DEFAULT_END, PERMISSION_DEFAULT_NAME,
	PERMISSION_DEFAULT_START
} from '../conf/permissions';

export class Permission {
	Id: number;
	UserId: number;
	SiteId: number;
	Name: string;
	Description: string;
	Email: string;
	Tz: string;
	CustomerLanguage: string;
	Start: Date;
	End: Date;
	Token: string;
	InvitationSent: Date;
	PinCode: string;
	CreatedAt: Date;
	Status?: string;
	Commands?: PermittedCommand[];
	Ths?: PermissionThs[];
	PinVisible: boolean;
	EnableRfid: boolean;
	EnablePincodeDevices: boolean;
	RfidQeCode?: string;
	RandomPincode?: boolean;
	SendPincodeRbe?: boolean;
	SendPincodeMtma?: boolean;
	SendRfidRbe?: boolean;
	SendRfidMtma?: boolean;
	SendMail?: boolean;
	SendAccessMail?: boolean;

	constructor() {
		this.Name = PERMISSION_DEFAULT_NAME;
		this.Start = PERMISSION_DEFAULT_START;
		this.End = PERMISSION_DEFAULT_END;
		this.Tz = undefined; // new default timezone is site timezone
		this.CustomerLanguage = DEFAULT_LANG.code;
		this.PinVisible = false;
		this.PinCode = null;
		this.EnableRfid = false;
		this.EnablePincodeDevices = false;
		this.RfidQeCode = null;
		this.RandomPincode = true;
		this.SendPincodeRbe = true;
		this.SendPincodeMtma = true;
		this.SendRfidRbe = false;
		this.SendRfidMtma = false;
		this.SendMail = true;
		this.SendAccessMail = true;
	}
}

export interface PermissionEvent {
	PermissionId: number;
}

export class PermittedCommand {
	Id?: number;
	PermissionId?: number;
	DeviceId: number;
	DeviceName: string;
	CommandId: number;
	CmdId?: number;
	CommandDescription: string;
	Inactive?: boolean;
	ModelId?: number;

	constructor() {
		this.Id = 0;
		this.CommandId = 0;
		this.CommandDescription = '';
		this.DeviceId = 0;
		this.DeviceName = '';
	}
}

export class GroupedPermittedCommandsItem {
	DeviceName: string;
	items: PermittedCommand[];

	constructor(deviceName?, commands?) {
		this.DeviceName = deviceName || '';
		this.items = [];
		if (commands) {
			this.items = commands;
		}
	}
}

export enum EPermissionStatus {
	Created = 'created',
	Ready = 'ready',
	Active = 'active',
	Expired = 'expired',
}

export class PermissionTemplate {
	Id?: number;
	ExtraInfo?: string;
	Name?: string;
	Phone?: string;
	Email?: string;
	Website?: string;
	Address?: string;
	ImageId?: string;
}

export class PermittedThs {
	Id?: number;
	Name?: string;
	ModelId?: number;
	QeEnable?: boolean;
	Inactive?: boolean;

	constructor() {
		this.Id = undefined;
		this.Name = '';
		this.ModelId = undefined;
		this.QeEnable = undefined;
		this.Inactive = false;
	}
}

export class AccessThermoBnB {
	Enable: boolean;
	DeltaTempP: number;
	DeltaTempN: number;
	Temp: number;
	thManualTempMin?: number;
	thManualTempMax?: number;
	thManualTempStepsValue?: number;
}

export class AccessThermoQnE {
	Enable: boolean;
	StdbyTemp: number;
	CourtesyTime: number;
}

export class PermissionThs {
	DeviceId?: number;
	DeviceName?: string;
}

export class PermittedAccessThs {
	DeviceId?: number;
	DeviceName?: string;
	Keycode?: string;
	ManualTemp?: number;
	TempLoc?: number;
	HumLoc?: number;
	Mode?: string;
	CurrentSeason?: string;
	RelayStatus?: number;
	Bb?: AccessThermoBnB;
	Qe?: AccessThermoQnE;
	Online?: number;
}

export class AccessPermission {
	Start: Date;
	End: Date;
	Commands?: PermittedCommand[];
	Ths?: PermittedAccessThs[];

	constructor() {
		this.Start = PERMISSION_DEFAULT_START;
		this.End = PERMISSION_DEFAULT_END;
		this.Commands = undefined;
		this.Ths = undefined;
	}
}

export class AccessPermissionPoll {
	Start?: Date;
	End?: Date;
	Ths?: PermittedAccessThs[];
}